import { useGameStore } from '../../store/gameStore';
import { GothicFrame } from '../chrome/GothicChrome';
import { SvgIcon } from '../chrome/SvgIcon';
import { selectDungeon, selectHasSave, selectModeType } from '../../store/selectors';

/** Compact system menu. Mode-specific headings live in their owning React layouts. */
export function TopBar() {
  const dungeon = useGameStore(selectDungeon);
  const mode = useGameStore(selectModeType);
  const hasSave = useGameStore(selectHasSave);
  const reset = useGameStore((state) => state.reset);
  const saveGame = useGameStore((state) => state.saveGame);
  const loadGame = useGameStore((state) => state.loadGame);
  const deleteSave = useGameStore((state) => state.deleteSave);

  return (
    <div className="system-bar">
      <details className="system-menu">
        <summary aria-label="Mở menu hệ thống"><SvgIcon name="action-settings" /></summary>
        <div className="system-menu-popover gothic-panel">
          <GothicFrame />
          <small>HỆ THỐNG</small>
          <strong>Vô Tận Mê Cung</strong>
          <span>
            Tầng {dungeon.floorNumber.toString().padStart(2, '0')} · {mode === 'combat' ? 'Chiến đấu' : 'Thám hiểm'}
          </span>
          <div className="system-menu-actions">
            <button type="button" onClick={saveGame}><SvgIcon name="action-save" /> Lưu bằng Pha Lê</button>
            <button type="button" disabled={!hasSave} onClick={loadGame}><SvgIcon name="action-load" /> Tải bản lưu</button>
            <button type="button" disabled={!hasSave} onClick={deleteSave}><SvgIcon name="action-delete-save" /> Xóa bản lưu</button>
            <button type="button" className="danger-text" onClick={reset}><SvgIcon name="action-reset" /> Chơi lại</button>
          </div>
        </div>
      </details>
    </div>
  );
}
